export default {"src":"/_next/static/media/fitness.9a5f4195.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};